import { MantineThemeOverride, rem } from '@mantine/core';
import { TABLET_BREAKPOINT } from 'theme/components/utils/tablet';

export type TabsTheme = NonNullable<MantineThemeOverride['components']>['Tabs'];

export const Tabs: TabsTheme = {
  variants: {
    pills: (theme) => ({
      tabsList: {
        gap: rem(8),
      },
      tab: {
        paddingTop: rem(12),
        paddingBottom: rem(12),
        paddingLeft: rem(32),
        paddingRight: rem(32),
        fontSize: rem(16),
        lineHeight: 1.5,
        fontWeight: 500,
        borderRadius: rem(4),
        cursor: 'pointer',
        transition: 'background 100ms ease',
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          paddingTop: rem(8),
          paddingBottom: rem(8),
          paddingLeft: rem(24),
          paddingRight: rem(24),
          fontSize: rem(14),
        },
      },
    }),
  },
};
